exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6c10777e]{color:#818a91}h1[data-v-6c10777e]{font-size:1.6rem;font-weight:700;text-align:center}h2[data-v-6c10777e]{font-size:1.38rem}h2[data-v-6c10777e]:nth-child(2){font-weight:700}h2.percentage[data-v-6c10777e]{font-size:2.6rem;text-align:center;margin-top:3rem;font-weight:unset}.flex-just[data-v-6c10777e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.card[data-v-6c10777e]{width:45%}.card.conversion[data-v-6c10777e]{width:100%}@media (max-width:758px){.flex-just.res[data-v-6c10777e]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card[data-v-6c10777e]{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c10777e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise/components/infoLeads.vue
// module id = V+vd
// module chunks = 0